/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { useFormContext } from "react-hook-form";

// CSS読み込み
import { inputArea_check, radioInput } from "assets/css/stylesCss";

/**
 * ラジオボタン
 * @param {String} id for属性用ID
 * @param {String} name react-hook-form管理用フォーム特定文字列
 * @param {String} value value属性用初期値
 * @param {String} children 子要素
 * @param {Object} rules バリデーション設定オブジェクト
 */
const RadioButton = memo(({ id, name, value, children, rules }) => {
  const { register } = useFormContext();

  return (
    <label css={inputArea_check} htmlFor={id}>
      <input
        {...register(name, { ...rules })}
        css={radioInput}
        type="radio"
        id={id}
        name={name}
        value={value}
      />
      {children}
    </label>
  );
});

export default RadioButton;
